import React, { FC } from "react";
import fallbackImage from "../../../../../prod/images/bg3.jpg";
import ArrowRightIcon from "../../../../../prod/images/redesign/arrowRight.svg?react";
import { Product } from "../../types/product/product.types";

export interface ProductCardProps extends Product {}

export const ProductCard: FC<ProductCardProps> = (props) => {
  return (
    <div className="flex-grow flex-shrink-0 pl-5 first:pl-[10px] md:first:pl-0">
      <div className="flex flex-col gap-4 md:max-w-96 max-w-80">
        <img
          alt={props.image?.text || "Missing image alt"}
          className="md:h-[440px] h-96 w-80 md:w-96 object-scale-down rounded"
          loading="lazy"
          decoding="async"
          src={props.image?.href || fallbackImage}
        />

        <div>
          <a className="flex justify-between" href={props.url}>
            <span className="text-primary text-2xl leading-6 text-balance max-w-72">
              {props.name}
            </span>
          </a>

          <p className="text-xs">Prod no. {props.catalogueNumber}</p>
        </div>
      </div>
    </div>
  );
};
